// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1itb9","search":"Settings_search__-Pyu8","filter":"Settings_filter__32Lkj"};